import styled, { css } from 'styled-components';
import { media } from '@deerplusofficial/pos-helper';

export default styled.div`
  ${media(
    'tablet',
    css`
      margin-top: 20px;
      padding-right: 18px;
      width: 50%;
    `
  )};
`;



// WEBPACK FOOTER //
// ./src/components/Info/InfoSectionWrapper.js